<template>
  <div class="home">
    <!-- <div class="page-content content-0"> -->
      <!-- banner图 -->
      <Banner />
      <!-- 滚动新闻 -->
      <ScrollNews />
       <Jmk />
       <Zpk />
       <wxk />
       <Hdk />
       <Zrzk />
       <Hjk />
    
  </div>
</template>

<script>
// @ is an alias to /src
import Header from '@/components/header.vue'
import Banner from '../components/banner.vue'
import Footer from '../components/footer.vue'
import ScrollNews from '../components/home/scrollnews.vue'
import Jmk from "../components/home/jmk.vue"
import Zrzk from "../components/home/zrzk.vue"
import Hdk from "../components/home/hdk.vue"
import Hjk from "../components/home/hjk.vue"
import Wxk from '@/components/home/wxk.vue'
import Zpk from '@/components/home/zpk.vue'

export default {
  name: 'Home',
  components: {
    Header,Banner,Footer,ScrollNews,Jmk,Zrzk,Hdk,Hjk,
    Wxk,Zpk
  },
  mounted() {
    this.$api.recordApi.addListRecord('首页')
  },
}
</script>
<style  scoped>
  .home{
    position: relative;
    width: 100%;
    
    left: 0;
    top: 0;
    z-index: 1;
    overflow: hidden;
    
  }
  .home .page-content{
      width: 100%;
      height: 100vh;
      background: #fff;
    }
  
</style>
